import { actionTypes } from "../actions/reports";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REPORT:
      return action.payload;
    default:
      return state;
  }
};

export default variable;